<mat-accordion multi="false">
  @for (question of questions; track question; let i = $index) {
    <app-expansion-panel
      [title]="i + 1 + '. ' + question.text.text_en"
      [description]="question.hasEntry ? 'answered' : 'not answered'"
      [descriptionClasses]="
        question.hasEntry
          ? ['question', 'answered']
          : ['question', 'unanswered']
      "
      [expanded]="i === expandedQuestionIndex()"
      (opened)="setQuestionExpandedIndex(i)"
      >
      @if (!question.hidden;) {
        <mat-radio-group
          class="radio-group"
          [ngModel]="getUserAnswer(question.id)"
          (ngModelChange)="onAnswerChange(question.id, $event)"
          >
          @for (answer of question.baselineAnswers; track answer) {
            <mat-radio-button [value]="answer.id" class="radio-button">
              {{ answer.text.text_en ? answer.text.text_en : answer.text.text_de }}
            </mat-radio-button>
          }
        </mat-radio-group>
        @if (i < questions.length - 1;) {
          <button class="btn btn-primary btn-align-right" (click)="nextQuestion()">Next Question</button>
        }
      }
    </app-expansion-panel>
    <!-- Special Case for flight entries. These Belong to the General Emissions but are not contained in the WWF Questions -->
  }
  @if (categoryName == 'Mobilität' || categoryName == 'Mobility') {
    <app-flights-expansion-panel
    ></app-flights-expansion-panel>
  }
</mat-accordion>
